import { useLocalSearchParams } from 'expo-router';
import TeamDetailLayout from '@/layouts/TeamDetail';

export default function PrivateTabsOrganizationEventTeamTeamIdLayoutRoute() {
  const { teamId } = useLocalSearchParams<{ teamId: string }>();

  return (
    <TeamDetailLayout
      basePath="/organization/event/team/[teamId]"
      badgesPathname="/organization/event/team/[teamId]/badge"
      teamId={teamId}
    />
  );
}
